import ProgressCard, { ProgressCardProps } from "../ProgressCard";
import styles from "./style.module.scss";
import { useState } from "react";
import VLSearchFilter from "views/uikit/VLSearchFilter";

export interface ProgressAndContentBarProps {
  items: ProgressCardProps[];
  text?: string;
  type?: string;
}

export default function ProgressCardList({
  items,
  text = "Annotated images",
  type,
}: ProgressAndContentBarProps) {
  const [filteredItems, setFilteredItems] = useState(items);

  return (
    <>
      <VLSearchFilter
        items={items}
        filterKey="label"
        placeholder="Search Labels"
        onFilter={setFilteredItems}
      />
      <div className={styles.wrapper}>
        <div className={styles.headers}>
          <div>Labels</div>
          <div>{text}</div>
        </div>
        {filteredItems.map((item, index) => (
          <ProgressCard
            key={index}
            label={item.label}
            maxItems={item.maxItems}
            itemLength={item.itemLength}
            active={item.active}
            onClick={item.onClick}
            id={item.id || index.toString()}
            type={type}
          />
        ))}
      </div>
    </>
  );
}
